import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pause",
  "use": "pause-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"pause\">\n  <path fill-rule=\"evenodd\" d=\"M45,347a11,11,0,1,0,11,11A11,11,0,0,0,45,347Zm0,19.938A8.938,8.938,0,1,1,53.938,358,8.938,8.938,0,0,1,45,366.938Zm-4.125-13.063h2.75v8.25h-2.75v-8.25h0Zm5.5,0h2.75v8.25h-2.75v-8.25Z\" transform=\"translate(-34 -347)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pause.svg
// module id = null
// module chunks = 